import React, { Component } from "react";
import { Row, Col, Form, Button, Select, Input, message } from "antd";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import ProjectStore from "../store/ProjectStore";
import DriversStore from "../store/DriversStore";
const { Option } = Select;

class AssignProjectToDriver extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.projectStore = new ProjectStore(this);
    this.driverStore = new DriversStore(this);
    this.formRef = React.createRef();
    this.state = {
      loadList: 0,
      companyId: "",
      projectId: this.props.projectId,
    };
  }
  async handleChange(comp) {
    console.log(comp.value);
    await this.setState({ companyId: comp.value });
    await this.projectStore.getProjectDetails(
      this.props.companyId,
      this.props.projectId
    );
    await this.driverStore.toGetDriverName(this.state.companyId);

    await this.setState({ loadList: 1 });
  }
  onAssignProjectToDriver = async (values) => {
    const data = {
      ...values,
      companyId: this.state.companyId,
      projectId: this.state.projectId,
    };
    console.log(data);
    const response = await this.projectStore.assignProject(data);
    // console.log(response)
    if (response.data.success === "S") {
      message.success("Project successfully assigned to driver");
      console.log(response);
    } else {
      message.error(response.data.message);
    }
    if (response.data.message) {
      this.formRef.current?.resetFields();
      this.props.closeModal();
    }
  };
  closeModal = () => {
    this.props.closeModal();
  };
  async componentDidMount() {
    const { projectId, companyId } = this.props;
    console.log(this.props);

    this.setState({ projectId: projectId, companyId: companyId });
    // Fetch project details
    const getProjectData = await this.projectStore.getProjectDetails(
      companyId,
      projectId
    );
    await this.formRef.current.setFieldsValue({
      Id: getProjectData[0].projectId,
      projectName: getProjectData[0].projectName,
    });

    // Fetch driver list for dropdown
    await this.driverStore.toGetDriverName(companyId);

    // Fetch assigned drivers
    const getAssignDrivers = await this.projectStore.getAssignDrivers(
      projectId
    );
    // console.log(getAssignDrivers?.length)
    if (getAssignDrivers?.length) {
      const driverIdArray = getAssignDrivers.map((item) => item.driverId);
      // console.log("object")
      this.formRef.current.setFieldsValue({
        driverId: driverIdArray,
      });
    }

    this.setState({ loadList: 1, projectId, companyId });
  }

  render() {
    return (
      <div style={{ padding: 0 }}>
        <div style={{ paddingBottom: "10px" }}>
          <Form
            style={{ maxWidth: "100%" }}
            ref={this.formRef}
            layout="vertical"
            onFinish={this.onAssignProjectToDriver}
            {...this.layout}
            name="nest-message"
            className="formClass"
          >
            <Row className="overflowFormInputs">
              <Col span={24} className="formColumnClass">
                <Form.Item
                  name="projectName"
                  value={this.state.projectId}
                  label={this.context.translate("_PROJECT_NAME_")}
                  disabled
                >
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  name="driverId"
                  rules={[{ required: true }]}
                  label={this.context.translate("_DRIVER_")}
                >
                  <Select
                    showSearch
                    mode="multiple"
                    maxTagCount="responsive"
                    name="driverId"
                    // fieldNames={{ label: "name", value: "driverId" }}
                    placeholder={this.context.translate("_DRIVER_")}
                    optionFilterProp="children"
                    // options={this.driverStore?.getDriverName}
                    filterOption={(inputValue, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {this.driverStore?.getDriverName?.map((val) => {
                      return (
                        <Option key={val.driverId} value={val.driverId}>
                          {val.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <div className="formBtnGroup">
              <Button
                className="formCancelButton"
                htmlType=""
                onClick={(e) => {
                  this.closeModal();
                }}
              >
                {/* Cancel */}
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="formSaveButton"
              >
                {/* Save */}
                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

AssignProjectToDriver.contextType = StoreContext;
export default observer(withRouter(AssignProjectToDriver));
